module.exports = __webpack_public_path__ + "assets/img/favicons/favicon-32x32.png";